var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDevelopertl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1721,
    height: 407,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400 26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M523.53 155.66a8 8 0 0 1 8-8H822.6a8 8 0 0 1 8 8v183.06a8 8 0 0 1-8 8H531.52a8 8 0 0 1-8-8z",
    stroke: "#1071e5",
    strokeWidth: 5,
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "matrix(1,0,0,1,528.5300793779909,152.65574503762082) translate(39.56666666666676 55.741666666666625)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "matrix(1,0,0,1,528.5300793779909,152.65574503762082) translate(83.59666666666674 110.52833333333322)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "matrix(1,0,0,1,528.5300793779909,152.65574503762082) translate(20.340000000000117 165.31499999999983)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-140 147.66c33.14 0 60 45.82 60 102.34s-26.86 102.34-60 102.34h-180c-33.14 0-60-45.82-60-102.34s26.86-102.34 60-102.34z",
    stroke: "#000",
    strokeOpacity: 0,
    strokeWidth: 5,
    fill: "#00c2a8"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "matrix(1,0,0,1,-375,152.65574503762082) translate(69.69277777777783 84.60694444444441)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    transform: "matrix(1,0,0,1,-375,152.65574503762082) translate(50.628333333333394 144.61138888888883)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.55 159.08a4.6 4.6 0 0 1 4.45-5.8h271.53a4.6 4.6 0 0 1 4.45 5.8l-50 187.47a7.8 7.8 0 0 1-7.53 5.8H139.08a7.8 7.8 0 0 1-7.54-5.8z",
    stroke: "#3a414a",
    strokeWidth: 5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    transform: "matrix(1,0,0,1,85,158.28155065090482) translate(83.865 55.74166666666667)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "matrix(1,0,0,1,85,158.28155065090482) translate(40.521666666666675 110.52833333333334)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    transform: "matrix(1,0,0,1,85,158.28155065090482) translate(55.24500000000001 165.315)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    transform: "matrix(1,0,0,1,85,158.28155065090482) translate(98.27166666666668 165.315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240 147.66c33.14 0 60 45.08 60 100.7 0 55.6-26.86 100.7-60 100.7h-180c-33.14 0-60-45.1-60-100.7 0-55.62 26.86-100.7 60-100.7z",
    stroke: "#000",
    strokeOpacity: 0,
    strokeWidth: 5,
    fill: "#008a0e"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j",
    transform: "matrix(1,0,0,1,1005,152.65574503762082) translate(26.028333333333386 85.86666666666665)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    transform: "matrix(1,0,0,1,1005,152.65574503762082) translate(46.18833333333337 140.65333333333328)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.5 250H78.35",
    stroke: "#3a414a",
    strokeWidth: 5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.44 252.5h-2.62l.06-2.5v-1.32l-.04-1.18h2.6z",
    stroke: "#3a414a",
    strokeWidth: 0.05,
    fill: "#3a414a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1 250l-14.25 4.63v-9.26z",
    stroke: "#3a414a",
    strokeWidth: 5,
    fill: "#3a414a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.08 252.8h154.1",
    stroke: "#3a414a",
    strokeWidth: 5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.14 255.3h-3.23l1.34-5h1.9z",
    stroke: "#3a414a",
    strokeWidth: 0.05,
    fill: "#3a414a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.94 252.8l-14.27 4.65v-9.27z",
    stroke: "#3a414a",
    strokeWidth: 5,
    fill: "#3a414a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.6 247.2h139.57",
    stroke: "#008a0e",
    strokeWidth: 5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.65 249.7h-2.56v-5h2.55z",
    stroke: "#008a0e",
    strokeWidth: 0.05,
    fill: "#008a0e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.94 247.2l-14.27 4.62v-9.27z",
    stroke: "#008a0e",
    strokeWidth: 5,
    fill: "#008a0e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-190 40c0 22.1-17.9 40-40 40s-40-17.9-40-40 17.9-40 40-40 40 17.9 40 40z",
    stroke: "#54c45e",
    strokeWidth: 9,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    transform: "matrix(1,0,0,1,-265,5) translate(22.325666666666677 48.2533333333333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.76 40c0 22.1-17.9 40-40 40s-40-17.9-40-40 17.9-40 40-40 40 17.9 40 40z",
    stroke: "#54c45e",
    strokeWidth: 9,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m",
    transform: "matrix(1,0,0,1,186.76503968899544,5) translate(20.52900000000001 48.2533333333333)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M717.06 40c0 22.1-17.9 40-40 40s-40-17.9-40-40 17.9-40 40-40 40 17.9 40 40z",
    stroke: "#54c45e",
    strokeWidth: 9,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n",
    transform: "matrix(1,0,0,1,642.0601587559818,5) translate(21.30300000000001 46.16444444444441)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1190 40c0 22.1-17.9 40-40 40s-40-17.9-40-40 17.9-40 40-40 40 17.9 40 40z",
    stroke: "#54c45e",
    strokeWidth: 9,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o",
    transform: "matrix(1,0,0,1,1115,5) translate(20.98377777777779 46.16444444444441)"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M175-710h445l-13 62H231l-55 256h328l-12 59H164L106-62h385L478 0H24",
    id: "p"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708-530c122-6 127 117 104 225L747 0h-68c23-125 58-238 71-372 12-124-128-108-187-54-32 29-64 66-84 108L412 0h-68c23-125 61-240 72-374 10-121-123-108-187-53-33 29-63 63-85 108L77 0H9l110-521h63l-26 118c46-65 117-125 214-127 82-2 119 52 119 136 48-73 117-131 219-136",
    id: "q"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262 10c-87 3-139-54-162-118L32 213h-68l156-734h60l-21 101c45-55 117-110 207-110 163 0 222 188 162 338C485-86 402 5 262 10zM115-181c16 73 58 131 141 131 108 0 171-79 206-160 56-132-25-305-178-250-59 21-122 59-135 119",
    id: "r"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104-118c-21 67 58 71 100 51l-2 55C132 21 8 18 32-95l134-635h68",
    id: "s"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335-530c169-5 238 187 171 339C458-83 367 5 220 10 50 15-17-177 50-329c48-108 139-197 285-201zM114-313C65-202 107-46 233-50c107-4 173-76 208-156 49-112 6-268-119-264-107 3-172 77-208 157",
    id: "t"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 169C75 161 108 79 158 8L51-521h71l84 458c89-150 180-276 228-458h67C443-306 325-148 214 26c-61 95-103 185-241 198",
    id: "u"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464-122C416-49 341 6 226 10 52 15-16-174 49-330c46-110 139-200 290-200 96 0 166 44 166 140 0 51-24 88-68 116-64 40-226 44-341 34-9 112 35 198 142 198 82 0 136-43 170-97zm-21-269c6-90-121-102-193-70-72 31-122 93-145 172 136 4 329 29 338-102",
    id: "v"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156-396c47-65 111-132 213-124l-13 59c-99 5-173 64-211 137L77 0H9l110-521h64",
    id: "w"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402-170C411 29 84 60-20-68l40-46c45 48 99 72 162 72 88 0 176-56 143-142-56-66-207-47-252-124-6-11-9-25-9-40 0-154 179-216 322-162 29 11 50 30 65 51l-42 40c-25-37-77-60-136-60-80 0-142 33-142 113 0 57 49 55 105 73 86 28 162 33 166 123",
    id: "x"
  }), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666662,0,0,0.04666666666666662,0,0)",
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666662,0,0,0.04666666666666662,26.739999999999974,0)",
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666662,0,0,0.04666666666666662,67.71333333333327,0)",
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666662,0,0,0.04666666666666662,95.38666666666657,0)",
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666662,0,0,0.04666666666666662,107.47333333333323,0)",
    xlinkHref: "#t"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666662,0,0,0.04666666666666662,133.46666666666653,0)",
    xlinkHref: "#u"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666662,0,0,0.04666666666666662,156.09999999999985,0)",
    xlinkHref: "#v"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666662,0,0,0.04666666666666662,181.01999999999984,0)",
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666662,0,0,0.04666666666666662,197.0266666666665,0)",
    xlinkHref: "#x"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M193-63c103-132 191-287 239-458h66C448-346 353-172 214 0h-73L58-521h71",
    id: "y"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119-521h68L77 0H9zm45-209h68l-21 100h-68",
    id: "z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363-184C323-119 278-58 228 0h-73L53-521h70l84 458c52-62 97-127 137-198l-60-260h70l38 173c27-56 49-112 67-173h65c-28 94-66 178-112 259l43 199c104-132 193-287 242-458h66C712-346 616-172 476 0h-73",
    id: "A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666662,0,0,0.04666666666666662,0,0)",
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666662,0,0,0.04666666666666662,14.793333333333319,0)",
    xlinkHref: "#v"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666662,0,0,0.04666666666666662,39.19999999999996,0)",
    xlinkHref: "#y"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666662,0,0,0.04666666666666662,62.11333333333327,0)",
    xlinkHref: "#z"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666662,0,0,0.04666666666666662,72.05333333333326,0)",
    xlinkHref: "#v"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666662,0,0,0.04666666666666662,96.45999999999991,0)",
    xlinkHref: "#A"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M418-101C375-44 299 9 210 10 46 12-13-179 49-328c44-105 126-196 265-202 85-4 140 56 162 118l24-109h68c-31 149-64 295-94 445 0 11 6 16 19 16L480 0c-44 11-85-10-70-58 2-9 4-23 8-43zM114-308C59-175 139-7 292-60c59-21 123-58 135-119l33-161c-10-101-126-165-226-108-53 30-95 81-120 140",
    id: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457-119C411-47 336 7 223 10 52 14-17-177 50-331c47-109 138-195 287-199 94-3 158 49 176 124l-70 21c-16-79-126-107-205-65-78 42-143 116-143 231 0 96 45 169 138 169 76 0 131-39 161-89",
    id: "C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126-128c-35 90 87 78 123 48l6 55C198 17 24 34 51-94l79-373H61l12-54h68l38-176h68l-38 176h114l-12 54H198",
    id: "D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392-530c121-7 122 121 100 225L428 0h-68c23-124 61-242 72-376 11-125-135-98-196-50-36 28-71 64-92 107L77 0H9l110-521h63l-26 118c54-66 123-120 236-127",
    id: "E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666662,0,0,0.04666666666666662,0,0)",
    xlinkHref: "#B"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666662,0,0,0.04666666666666662,27.906666666666638,0)",
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666662,0,0,0.04666666666666662,55.57999999999994,0)",
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666662,0,0,0.04666666666666662,83.25333333333325,0)",
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666662,0,0,0.04666666666666662,95.57333333333324,0)",
    xlinkHref: "#z"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666662,0,0,0.04666666666666662,105.51333333333322,0)",
    xlinkHref: "#C"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666662,0,0,0.04666666666666662,129.82666666666654,0)",
    xlinkHref: "#B"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666662,0,0,0.04666666666666662,157.73333333333318,0)",
    xlinkHref: "#D"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666662,0,0,0.04666666666666662,172.71333333333317,0)",
    xlinkHref: "#z"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666662,0,0,0.04666666666666662,182.65333333333317,0)",
    xlinkHref: "#t"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666662,0,0,0.04666666666666662,209.39333333333312,0)",
    xlinkHref: "#E"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666662,0,0,0.04666666666666662,235.47999999999982,0)",
    xlinkHref: "#x"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M597-159C535-67 437 6 294 6 127 6 47-126 47-294c0-186 113-311 243-382 87-48 234-55 308 5 36 29 60 66 71 112l-63 34c-21-78-76-126-171-126-159 0-249 111-295 231-61 161-1 363 171 363 113 0 183-60 234-132",
    id: "F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M156-396c47-65 111-132 213-124l-13 59c-99 5-173 64-211 137L77 0H9l110-521h64",
    id: "G"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M464-122C416-49 341 6 226 10 52 15-16-174 49-330c46-110 139-200 290-200 96 0 166 44 166 140 0 51-24 88-68 116-64 40-226 44-341 34-9 112 35 198 142 198 82 0 136-43 170-97zm-21-269c6-90-121-102-193-70-72 31-122 93-145 172 136 4 329 29 338-102",
    id: "H"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M418-101C375-44 299 9 210 10 46 12-13-179 49-328c44-105 126-196 265-202 85-4 140 56 162 118l24-109h68c-31 149-64 295-94 445 0 11 6 16 19 16L480 0c-44 11-85-10-70-58 2-9 4-23 8-43zM114-308C59-175 139-7 292-60c59-21 123-58 135-119l33-161c-10-101-126-165-226-108-53 30-95 81-120 140",
    id: "I"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M126-128c-35 90 87 78 123 48l6 55C198 17 24 34 51-94l79-373H61l12-54h68l38-176h68l-38 176h114l-12 54H198",
    id: "J"
  }), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,0,0)",
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,33.528888888888865,0)",
    xlinkHref: "#G"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,49.731111111111076,0)",
    xlinkHref: "#H"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,77.02444444444438,0)",
    xlinkHref: "#I"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,107.58888888888882,0)",
    xlinkHref: "#J"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,123.33111111111103,0)",
    xlinkHref: "#H"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M386-710h60L574 0h-74l-39-222H162L30 0h-75zm71 433l-58-351-211 351h269",
    id: "K"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M457-119C411-47 336 7 223 10 52 14-17-177 50-331c47-109 138-195 287-199 94-3 158 49 176 124l-70 21c-16-79-126-107-205-65-78 42-143 116-143 231 0 96 45 169 138 169 76 0 131-39 161-89",
    id: "L"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M335-530c169-5 238 187 171 339C458-83 367 5 220 10 50 15-17-177 50-329c48-108 139-197 285-201zM114-313C65-202 107-46 233-50c107-4 173-76 208-156 49-112 6-268-119-264-107 3-172 77-208 157",
    id: "M"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M394-118C343-50 264 4 159 10 43 17 24-102 48-215l66-306h67c-23 123-59 241-72 372C96-24 242-37 308-89c36-28 70-62 93-104l70-328h68c-31 148-94 291-94 444 0 11 6 17 19 17L451 0c-45 10-82-9-69-59 5-19 7-36 12-59",
    id: "N"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M392-530c121-7 122 121 100 225L428 0h-68c23-124 61-242 72-376 11-125-135-98-196-50-36 28-71 64-92 107L77 0H9l110-521h63l-26 118c54-66 123-120 236-127",
    id: "O"
  }), /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,0,0)",
    xlinkHref: "#K"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,32.40444444444442,0)",
    xlinkHref: "#L"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,59.033333333333296,0)",
    xlinkHref: "#L"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,85.66222222222217,0)",
    xlinkHref: "#M"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,114.94888888888882,0)",
    xlinkHref: "#N"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,144.03111111111102,0)",
    xlinkHref: "#O"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,172.34666666666655,0)",
    xlinkHref: "#J"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86-710L340-87l253-623h73L370 0h-61L13-710h73",
    id: "P"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 0v-521h68V0H75zm0-630v-100h68v100H75",
    id: "Q"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522-120C485-42 411 10 300 10 138 10 39-100 39-262c0-161 99-268 260-268 168 0 260 118 257 294H110c14 112 76 194 193 194 79 0 133-38 160-94zm-30-168c-9-131-125-225-264-175-69 25-111 88-119 175h383",
    id: "R"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731-521h67L574 0h-56L406-266 295 0h-56L15-521h66L271-70l99-238-89-212h57l68 170 68-170h58l-89 212 99 238",
    id: "S"
  }), /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666667,0,0,0.04666666666666667,0,0)",
    xlinkHref: "#P"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666667,0,0,0.04666666666666667,31.686666666666667,0)",
    xlinkHref: "#Q"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666667,0,0,0.04666666666666667,41.86,0)",
    xlinkHref: "#R"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666667,0,0,0.04666666666666667,68.6,0)",
    xlinkHref: "#S"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M577-260c0 156-83 264-236 270-95 4-160-57-198-118v321H75v-734h61v101c45-83 181-146 293-88 84 43 148 126 148 248zm-434 79c33 69 84 131 179 131 119 0 186-90 186-210 0-122-73-210-194-210-87 0-151 54-171 129v160",
    id: "T"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556-259c0 160-98 269-259 269S39-99 39-259c0-125 67-206 155-249 61-29 145-29 206 0 89 43 156 123 156 249zM297-470c-119 0-189 90-189 212 0 121 70 208 189 208s190-88 190-210c0-121-71-210-190-210",
    id: "U"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438-202C513-35 297 54 129-10 91-25 57-43 29-68l31-46c52 41 104 69 187 72 88 4 165-51 128-134-69-79-256-49-311-144-7-14-11-31-11-52-9-188 290-194 383-87l-33 40c-59-86-330-92-278 71 72 78 268 45 313 146",
    id: "V"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165-113c-1 73 106 62 142 33l18 55C293-10 255 6 207 6 141 6 97-28 97-94v-373H25v-54h72v-176h68v176h120v54H165v354",
    id: "W"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358-530c125 0 154 99 155 225V0h-68v-291c-1-106-21-177-112-177-102 0-161 68-190 149V0H75v-521h62v118c37-69 120-127 221-127",
    id: "X"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666667,0,0,0.04666666666666667,0,0)",
    xlinkHref: "#T"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666667,0,0,0.04666666666666667,28.793333333333333,0)",
    xlinkHref: "#U"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666667,0,0,0.04666666666666667,56.56,0)",
    xlinkHref: "#V"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666667,0,0,0.04666666666666667,79.28666666666666,0)",
    xlinkHref: "#Q"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666667,0,0,0.04666666666666667,89.46,0)",
    xlinkHref: "#W"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666667,0,0,0.04666666666666667,105.09333333333333,0)",
    xlinkHref: "#Q"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666667,0,0,0.04666666666666667,115.26666666666667,0)",
    xlinkHref: "#U"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666667,0,0,0.04666666666666667,143.03333333333333,0)",
    xlinkHref: "#X"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666667,0,0,0.04666666666666667,170.24,0)",
    xlinkHref: "#V"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M589-356c-2 88-25 161-61 218L661 0h-90l-82-86c-50 53-119 96-215 96C144 10 47-56 47-183c0-114 81-160 150-211-43-52-97-86-97-169 0-101 75-156 178-156 95 0 166 47 166 140 0 105-88 142-155 191l199 208c25-47 43-106 43-176h58zM113-181C113-58 268-16 375-66c29-14 54-35 76-60L236-353c-57 44-123 84-123 172zm165-485c-84 0-144 79-98 152 19 31 41 55 70 85 58-44 126-69 131-148 4-53-47-89-103-89",
    id: "Y"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666667,0,0,0.04666666666666667,0,0)",
    xlinkHref: "#Y",
    id: "h"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33-152c0-163 233-183 372-130 12-119-39-199-147-197-69 1-119 29-167 62l-24-45c67-45 133-68 196-68 129-1 210 79 210 207v235c0 19 8 28 25 28V0c-44 11-80-5-82-46l-2-41c-42 57-115 97-208 97C103 10 33-50 33-152zm65-5C94-6 333-21 387-115c28-21 15-79 18-124-100-44-304-44-307 82",
    id: "Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 6C117 6 77-32 78-95v-635h68v612c-6 63 67 74 115 51l12 55c-21 9-65 18-94 18",
    id: "aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252 151c-17 51-73 85-147 69v-60c37 4 66 3 79-25 20-43 33-79 58-135L15-521h70L278-63l179-458h65",
    id: "ab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666667,0,0,0.04666666666666667,0,0)",
    xlinkHref: "#Z"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666667,0,0,0.04666666666666667,25.433333333333334,0)",
    xlinkHref: "#T"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666667,0,0,0.04666666666666667,54.22666666666667,0)",
    xlinkHref: "#T"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666667,0,0,0.04666666666666667,83.02,0)",
    xlinkHref: "#aa"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666667,0,0,0.04666666666666667,95.19999999999999,0)",
    xlinkHref: "#ab"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M262 10c-87 3-139-54-162-118L32 213h-68l156-734h60l-21 101c45-55 117-110 207-110 163 0 222 188 162 338C485-86 402 5 262 10zM115-181c16 73 58 131 141 131 108 0 171-79 206-160 56-132-25-305-178-250-59 21-122 59-135 119",
    id: "ac"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M104-118c-21 67 58 71 100 51l-2 55C132 21 8 18 32-95l134-635h68",
    id: "ad"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M119-521h68L77 0H9zm45-209h68l-21 100h-68",
    id: "ae"
  }), /*#__PURE__*/React.createElement("g", {
    id: "j"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,0,0)",
    xlinkHref: "#K"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,30.37999999999999,0)",
    xlinkHref: "#ac"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,58.05333333333331,0)",
    xlinkHref: "#ac"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,85.72666666666663,0)",
    xlinkHref: "#ad"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,98.04666666666662,0)",
    xlinkHref: "#ae"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,107.98666666666662,0)",
    xlinkHref: "#L"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,132.29999999999995,0)",
    xlinkHref: "#I"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,160.20666666666662,0)",
    xlinkHref: "#J"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,175.1866666666666,0)",
    xlinkHref: "#ae"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,185.1266666666666,0)",
    xlinkHref: "#M"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,211.8666666666666,0)",
    xlinkHref: "#O"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M418-101C375-44 299 9 211 10 46 12-13-179 49-328c44-105 127-196 266-202 84-4 139 56 161 118l68-318h68c-46 218-93 434-138 653 0 11 6 17 19 17L480 0c-45 10-84-10-71-58 1-8 4-22 9-43zM114-309C59-176 139-7 292-60c59-21 123-58 135-119l33-161c-10-101-125-165-226-108-54 30-95 80-120 139",
    id: "af"
  }), /*#__PURE__*/React.createElement("g", {
    id: "k"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,0,0)",
    xlinkHref: "#K"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,29.586666666666655,0)",
    xlinkHref: "#L"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,53.89999999999998,0)",
    xlinkHref: "#L"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,78.2133333333333,0)",
    xlinkHref: "#H"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,103.1333333333333,0)",
    xlinkHref: "#ac"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,130.43333333333328,0)",
    xlinkHref: "#J"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,144.80666666666662,0)",
    xlinkHref: "#H"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,169.7266666666666,0)",
    xlinkHref: "#af"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3a414a",
    d: "M44-476c67-11 125-55 162-95h137v450h127V0H64v-121h142v-303c-37 37-95 67-162 73v-125",
    id: "ag"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.0513333333333333,0,0,0.0513333333333333,0,0)",
    xlinkHref: "#ag",
    id: "l"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3a414a",
    d: "M294-581c124 0 215 51 215 170 0 180-216 173-292 290h303V0H38C27-211 193-250 320-329c24-15 43-29 43-62 0-45-41-75-93-73-69 2-107 39-140 77l-86-99c57-53 140-95 250-95",
    id: "ah"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.0513333333333333,0,0,0.0513333333333333,0,0)",
    xlinkHref: "#ah",
    id: "m"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3a414a",
    d: "M508-399c0 90-51 145-127 163 80 13 142 85 139 178-5 144-110 205-260 205-106 0-183-36-232-96l76-95c34 42 77 69 152 69S381-1 381-73c0-88-76-113-177-108v-100c89 7 159-23 161-98 1-57-44-81-101-81-68 1-115 35-142 80l-84-94c47-65 132-102 241-102 128 0 229 52 229 177",
    id: "ai"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04911111111111108,0,0,0.04911111111111108,0,0)",
    xlinkHref: "#ai",
    id: "n"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3a414a",
    d: "M312 127V-22H20v-119l335-430h91v429h88v120h-88v149H312zM154-142h173v-226",
    id: "aj"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04911111111111108,0,0,0.04911111111111108,0,0)",
    xlinkHref: "#aj",
    id: "o"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopertl);
export default __webpack_public_path__ + "static/media/Developer tl.33f0cc8a9eb6d8a3604b789c4873afca.svg";
export { ForwardRef as ReactComponent };